'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const Styles = styleEncapsulation.labelStyles("InteractiveTags", {
  root: react.css`
    ${styleMixins_reset.listReset};
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: var(--zds-space-8);
  `
});
const InteractiveTags = (props) => {
  const tags = React__default.default.Children.toArray(props.children).filter(Boolean).map((child, i) => {
    return react.jsx("li", { key: i }, child);
  });
  return react.jsx("ul", { "aria-label": props["aria-label"], css: Styles.root, "data-zds": true }, tags);
};

exports.InteractiveTags = InteractiveTags;
//# sourceMappingURL=InteractiveTags.cjs.js.map
